import { render, staticRenderFns } from "./ImageDrawer.vue?vue&type=template&id=516f2ac6"
import script from "./ImageDrawer.vue?vue&type=script&lang=ts"
export * from "./ImageDrawer.vue?vue&type=script&lang=ts"
import style0 from "./ImageDrawer.vue?vue&type=style&index=0&id=516f2ac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBtn: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseBtn.vue').default})
